import { NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NavbarComponent } from './modules/navbar/navbar.component';
import { SidebarComponent } from './modules/sidebar/sidebar.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {MatDividerModule} from '@angular/material/divider';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import {MatListModule} from '@angular/material/list';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthInterceptor} from './shared/interceptor/auth.interceptor';
import { ListComponent } from './modules/partners/list/list.component';
import { AddComponent } from './modules/partners/add/add.component';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorIntl, MatPaginatorModule} from '@angular/material/paginator';
import {getPolishPaginationIntl} from './shared/i18n/polish-paginator';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { DictComponent } from './shared/components/dict/dict.component';
import {MatSelectModule} from '@angular/material/select';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { DictRegionalsComponent } from './shared/components/dict-regionals/dict-regionals.component';
import {MatCardModule} from '@angular/material/card';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatChipsModule} from '@angular/material/chips';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { AddressFormComponent } from './modules/addresses/address-form/address-form.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { ChipsInputControlComponent } from './shared/components/chips-input-control/chips-input-control.component';
import { ShowComponent } from './modules/partners/show/show.component';
import {MatTabsModule} from '@angular/material/tabs';
import { FacilitiesListComponent } from './modules/facilities/facilities-list/facilities-list.component';
import { FacilityAddDialogComponent } from './modules/facilities/facility-add-dialog/facility-add-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import { AllFacilitiesListComponent } from './modules/facilities/all-facilities-list/all-facilities-list.component';
import { DictPartnersComponent } from './shared/components/dict-partners/dict-partners.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { FacilityDetailsComponent } from './modules/facilities/facility-details/facility-details.component';
import { FacilityAddComponent } from './modules/facilities/facility-add/facility-add.component';
import {PhonePipe} from './shared/pipe/phone-number';
import {MinutesToHHmmPipe} from './shared/pipe/minutes-to-hh-mm';
import {DynamicPipe} from './shared/pipe/dynamic';
import { OfwcaAddComponent } from './modules/ofwcas/ofwca-add/ofwca-add.component';
import { OfwcaDetailsComponent } from './modules/ofwcas/ofwca-details/ofwca-details.component';
import { OfwcaAddDialogComponent } from './modules/ofwcas/ofwca-add-dialog/ofwca-add-dialog.component';
import { AllOfwcasListComponent } from './modules/ofwcas/all-ofwcas-list/all-ofwcas-list.component';
import { OfwcasListComponent } from './modules/ofwcas/ofwcas-list/ofwcas-list.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import { DatepickerComponent } from './shared/components/datepicker/datepicker.component';
import { PartnerFacilitySelectComponent } from './shared/components/partner-facility-select/partner-facility-select.component';
import { DictOfwcasComponent } from './shared/components/dict-ofwcas/dict-ofwcas.component';
import { AllInsuranceCompaniesListComponent } from './modules/insurance-companies/all-insurance-companies-list/all-insurance-companies-list.component';
import { InsuranceCompanyDetailsComponent } from './modules/insurance-companies/insurance-company-details/insurance-company-details.component';
import {MaterialFileInputModule} from 'ngx-material-file-input';
import { DocumentAddComponent } from './modules/documents/document-add/document-add.component';
import { AllDocumentListComponent } from './modules/documents/all-document-list/all-document-list.component';
import { ContractAddComponent } from './modules/contracts/contract-add/contract-add.component';
import { ContractAddDialogComponent } from './modules/contracts/contract-add-dialog/contract-add-dialog.component';
import { ContractDetailsComponent } from './modules/contracts/contract-details/contract-details.component';
import { ContractListComponent } from './modules/contracts/contract-list/contract-list.component';
import { AllContractListComponent } from './modules/contracts/all-contract-list/all-contract-list.component';
import { ContractDetailsFormComponent } from './modules/contracts/contract-details-form/contract-details-form.component';
import { ContractSelectCardComponent } from './modules/forms/contract-select-card/contract-select-card.component';
import { DocumentListComponent } from './modules/documents/document-list/document-list.component';
import { DocumentAddDialogComponent } from './modules/documents/document-add-dialog/document-add-dialog.component';
import { DocumentDetailsComponent } from './modules/documents/document-details/document-details.component';
import { DetailComponent } from './shared/components/details/detail/detail.component';
import { DetailAddressComponent } from './shared/components/details/detail-address/detail-address.component';
import { PartnerDetailsViewComponent } from './modules/partners/partner-details-view/partner-details-view.component';
import {PrimaryContactPipe} from './shared/pipe/primary-contact';
import {BillingContactPipe} from './shared/pipe/billing-contact';
import {MarketingContactPipe} from './shared/pipe/marketing-contact';
import {MatTooltipModule} from '@angular/material/tooltip';
import { FacilityDetailsViewComponent } from './modules/facilities/facility-details-view/facility-details-view.component';
import { OfwcaDetailsViewComponent } from './modules/ofwcas/ofwca-details-view/ofwca-details-view.component';
import { ContractDetailsViewComponent } from './modules/contracts/contract-details-view/contract-details-view.component';
import { DictInsuranceCompaniesComponent } from './shared/components/dict-insurance-companies/dict-insurance-companies.component';
import { DetailBoolComponent } from './shared/components/details/detail-bool/detail-bool.component';
import { DocumentDetailsViewComponent } from './modules/documents/document-details-view/document-details-view.component';
import { AllTemplateListComponent } from './modules/templates/all-template-list/all-template-list.component';
import { TemplateAddComponent } from './modules/templates/template-add/template-add.component';
import { TemplateDetailsComponent } from './modules/templates/template-details/template-details.component';
import { TemplateDetailsViewComponent } from './modules/templates/template-details-view/template-details-view.component';
import { TemplatingConfigMapComponent } from './modules/templates/templating-config-map/templating-config-map.component';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';
import {KeyValuePipe} from '@angular/common';
import {MatExpansionModule} from '@angular/material/expansion';
import { TodoComponent } from './shared/components/todo/todo.component';
import { TemplatingConfigFieldsComponent } from './modules/templates/templating-config-fields/templating-config-fields.component';
import { TableAddressComponent } from './shared/components/table/table-address/table-address.component';
import { DictContractsComponent } from './shared/components/dict-contracts/dict-contracts.component';
import { UserAddComponent } from './modules/user/user-add/user-add.component';
import { AllUserListComponent } from './modules/user/all-user-list/all-user-list.component';
import { UserDetailsComponent } from './modules/user/user-details/user-details.component';
import { UserDetailsViewComponent } from './modules/user/user-details-view/user-details-view.component';
import { AllDepartmentListComponent } from './modules/department/all-department-list/all-department-list.component';
import { DepartmentAddComponent } from './modules/department/department-add/department-add.component';
import { DepartmentDetailsComponent } from './modules/department/department-details/department-details.component';
import { DepartmentDetailsViewComponent } from './modules/department/department-details-view/department-details-view.component';
import { DictDepartmentsComponent } from './shared/components/dict-departments/dict-departments.component';
import { DictUsersComponent } from './shared/components/dict-users/dict-users.component';
import { PermissionsComponent } from './modules/forms/permissions/permissions.component';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {AccessDeniedInterceptor} from './shared/interceptor/access-denied.interceptor';
import { CapitalizeFirstDirective } from './shared/directive/capitalize-first.directive';
import {ImageCropperModule} from 'ngx-image-cropper';
import { AvatarCropDialogComponent } from './modules/user/avatar-crop-dialog/avatar-crop-dialog.component';
import { ChangePasswordDialogComponent } from './modules/user/change-password-dialog/change-password-dialog.component';
import { ProfileDialogComponent } from './modules/user/profile-dialog/profile-dialog.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSortModule} from '@angular/material/sort';
import { SlideFormFieldComponent } from './modules/forms/slide-form-field/slide-form-field.component';
import { LogListComponent } from './modules/log/log-list/log-list.component';
import { AllKrkListComponent } from './modules/krk/all-krk-list/all-krk-list.component';
import { KrkListComponent } from './modules/krk/krk-list/krk-list.component';
import { KrkAddComponent } from './modules/krk/krk-add/krk-add.component';
import { KrkAddDialogComponent } from './modules/krk/krk-add-dialog/krk-add-dialog.component';
import { KrkDetailsComponent } from './modules/krk/krk-details/krk-details.component';
import { KrkDetailsViewComponent } from './modules/krk/krk-details-view/krk-details-view.component';
import { DictKrkComponent } from './shared/components/dict-krk/dict-krk.component';
import { PendingKrkListComponent } from './modules/krk/pending-krk-list/pending-krk-list.component';
import { RegistrationAddComponent } from './modules/registrations/registration-add/registration-add.component';
import { AllRegistrationsListComponent } from './modules/registrations/all-registrations-list/all-registrations-list.component';
import { RegistrationDetailsComponent } from './modules/registrations/registration-details/registration-details.component';
import { RegistrationAddDialogComponent } from './modules/registrations/registration-add-dialog/registration-add-dialog.component';
import { DictAllContractsComponent } from './shared/components/dict-all-contracts/dict-all-contracts.component';
import { RegistrationDetailsViewComponent } from './modules/registrations/registration-details-view/registration-details-view.component';
import { RegistrationDetailsFormComponent } from './modules/registrations/registration-details-form/registration-details-form.component';
import { DictRegistrationsComponent } from './shared/components/dict-registrations/dict-registrations.component';
import {DaysDiffPipe} from './shared/pipe/days-diff';
import { MultiLineOptionDirective } from './shared/directive/multi-line-option.directive';
import { DeregistrationPackAddComponent } from './modules/deregistration-pack/deregistration-pack-add/deregistration-pack-add.component';
import { DeregistrationPackDetailsComponent } from './modules/deregistration-pack/deregistration-pack-details/deregistration-pack-details.component';
import { DeregistrationPackDetailsViewComponent } from './modules/deregistration-pack/deregistration-pack-details-view/deregistration-pack-details-view.component';
import { AllDeregistrationPackListComponent } from './modules/deregistration-pack/all-deregistration-pack-list/all-deregistration-pack-list.component';
import { AddRegistrationComponent } from './modules/deregistration-pack/add-registration/add-registration.component';
import { DictDeregistrationPacksComponent } from './shared/components/dict-deregistration-packs/dict-deregistration-packs.component';
import { ContractTerminateDialogComponent } from './modules/contracts/contract-terminate-dialog/contract-terminate-dialog.component';
import { InfoDialogComponent } from './shared/components/info-dialog/info-dialog.component';
import { ContractInsuranceCompaniesAddDialogComponent } from './modules/contracts/contract-insurance-companies-add-dialog/contract-insurance-companies-add-dialog.component';
import { AllContractInsuranceCompaniesListComponent } from './modules/contracts/all-contract-insurance-companies-list/all-contract-insurance-companies-list.component';
import { AllIdentifiersListComponent } from './modules/identifiers/all-identifiers-list/all-identifiers-list.component';
import {MatRadioModule} from '@angular/material/radio';
import { IdentifierImportComponent } from './modules/identifiers/identifier-import/identifier-import.component';
import { SlideToggleComponent } from './shared/components/slide-toggle/slide-toggle.component';
import { ConfirmDialogWithReasonComponent } from './shared/components/confirm-dialog-with-reason/confirm-dialog-with-reason.component';
import { AllSalesProfilesListComponent } from './modules/registrations/all-sales-profiles-list/all-sales-profiles-list.component';
import { AllMeetingsListComponent } from './modules/meetings/all-meetings-list/all-meetings-list.component';
import { MeetingAddComponent } from './modules/meetings/meeting-add/meeting-add.component';
import { MeetingDetailsComponent } from './modules/meetings/meeting-details/meeting-details.component';
import { MeetingDetailsViewComponent } from './modules/meetings/meeting-details-view/meeting-details-view.component';
import { MeetingsCalendarComponent } from './modules/meetings/meetings-calendar/meetings-calendar.component';
import { MeetingCalendarEventComponent } from './modules/meetings/meeting-calendar-event/meeting-calendar-event.component';
import { MonthPickerComponent } from './shared/components/month-picker/month-picker.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {EnumeratePipe} from './shared/pipe/enumerate';
import { ExamSelectDialogComponent } from './modules/meetings/exam-select-dialog/exam-select-dialog.component';
import { RegisteredOfwcasListComponent } from './modules/meetings/registered-ofwcas-list/registered-ofwcas-list.component';
import { OfwcaToRegisterListComponent } from './modules/meetings/ofwca-to-register-list/ofwca-to-register-list.component';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { OfwcaMeetingListComponent } from './modules/meetings/ofwca-meeting-list/ofwca-meeting-list.component';
import { JobResultDialogComponent } from './shared/components/job-result-dialog/job-result-dialog.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { AllIddTrainingsListComponent } from './modules/idd-trainings/all-idd-trainings-list/all-idd-trainings-list.component';
import { IddTrainingDetailsComponent } from './modules/idd-trainings/idd-training-details/idd-training-details.component';
import { IddTrainingDetailsViewComponent } from './modules/idd-trainings/idd-training-details-view/idd-training-details-view.component';
import { AddIddTrainingCertificateComponent } from './modules/idd-trainings/add-idd-training-certificate/add-idd-training-certificate.component';
import { IddTrainingChartComponent } from './modules/idd-trainings/idd-training-chart/idd-training-chart.component';
import { AllIddTrainingCertificatesListComponent } from './modules/idd-trainings/all-idd-training-certificates-list/all-idd-training-certificates-list.component';
import { AddIddTrainingCertificateDialogComponent } from './modules/idd-trainings/add-idd-training-certificate-dialog/add-idd-training-certificate-dialog.component';
import { DecodeIddTrainingCertificatesComponent } from './modules/idd-trainings/decode-idd-training-certificates/decode-idd-training-certificates.component';
import { DatepickerIdFormatComponent } from './shared/components/datepicker-id-format/datepicker-id-format.component';
import { FileDragAndDropComponent } from './shared/components/file-drag-and-drop/file-drag-and-drop.component';
import { DndDirective } from './shared/directive/dnd.directive';
import { CertificateOverviewDialogComponent } from './modules/idd-trainings/certificate-overview-dialog/certificate-overview-dialog.component';
import { GoogleAuthenticatorDialogComponent } from './modules/user/google-authenticator-dialog/google-authenticator-dialog.component';
import {NgxMaskModule} from 'ngx-mask';
import { OfwcaToReassignListComponent } from './modules/contracts/ofwca-to-reassign-list/ofwca-to-reassign-list.component';
import { ChangeRegionalDialogComponent } from './modules/ofwcas/change-regional-dialog/change-regional-dialog.component';
import { ChangeRegionalDialogComponent as PartnerChangeRegionalDialogComponent} from './modules/partners/change-regional-dialog/change-regional-dialog.component';
import {MatBadgeModule} from '@angular/material/badge';
import { AllImportsListComponent } from './modules/identifiers/all-imports-list/all-imports-list.component';
import { ImportResultDialogComponent } from './modules/identifiers/import-result-dialog/import-result-dialog.component';
import { SoldPolicyImportComponent } from './modules/sold-policy/sold-policy-import/sold-policy-import.component';
import { AllPoliciesListComponent } from './modules/sold-policy/all-policies-list/all-policies-list.component';
import { ReportsComponent } from './modules/sold-policy/reports/reports.component';
import { AllImportsListComponent as AllSoldPolicyImportsListComponent } from './modules/sold-policy/all-imports-list/all-imports-list.component';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {StoreRouterConnectingModule} from '@ngrx/router-store';
import {RouteSerializer} from './shared/ngrx/route-serializer';
import {reducers} from './shared/ngrx/reducers';
import { MiddleClickDirective } from './shared/directive/middle-click.directive';
import { AddRiskComponent } from './modules/settlements/risks/add-risk/add-risk.component';
import { AllRisksListComponent } from './modules/settlements/risks/all-risks-list/all-risks-list.component';
import { RiskGroupFormComponent } from './modules/settlements/risks/risk-group-form/risk-group-form.component';
import { RiskGroupViewComponent } from './modules/settlements/risks/risk-group-view/risk-group-view.component';
import { CommissionImportComponent } from './modules/settlements/imports/commission-import/commission-import.component';
import { AllCommissionsListComponent } from './modules/settlements/imports/all-commissions-list/all-commissions-list.component';
import {AllImportsListComponent as AllCommissionImportListComponent} from './modules/settlements/imports/all-imports-list/all-imports-list.component';
import { CommissionDetailsComponent } from './modules/settlements/imports/commission-details/commission-details.component';
import { CommissionDetailsViewComponent } from './modules/settlements/imports/commission-details-view/commission-details-view.component';
import { ChildPartnersListComponent } from './modules/partners/child-partners-list/child-partners-list.component';
import { EditRiskModalComponent } from './modules/settlements/risks/edit-risk-modal/edit-risk-modal.component';
import { AllRedirectionsListComponent } from './modules/settlements/redirections/all-redirections-list/all-redirections-list.component';
import { RedirectionAddComponent } from './modules/settlements/redirections/redirection-add/redirection-add.component';
import { RedirectionDetailsComponent } from './modules/settlements/redirections/redirection-details/redirection-details.component';
import { RedirectionDetailsViewComponent } from './modules/settlements/redirections/redirection-details-view/redirection-details-view.component';
import { JobsListComponent } from './modules/settlements/jobs-list/jobs-list.component';
import { ChangePartnerDialogComponent } from './modules/ofwcas/change-partner-dialog/change-partner-dialog.component';
import { DictPartnersChipsComponent } from './shared/components/dict-partners-chips/dict-partners-chips.component';
import { CommissionDetailsFormComponent } from './modules/settlements/imports/commission-details-form/commission-details-form.component';
import { AllSettlementsListComponent } from './modules/settlements/settlements/all-settlements-list/all-settlements-list.component';
import { SettlementDetailsComponent } from './modules/settlements/settlements/settlement-details/settlement-details.component';
import { SettlementDetailsViewComponent } from './modules/settlements/settlements/settlement-details-view/settlement-details-view.component';
import { AllRedirectionImportsListComponent } from './modules/settlements/redirections/all-redirection-imports-list/all-redirection-imports-list.component';
import { RedirectionImportComponent } from './modules/settlements/redirections/redirection-import/redirection-import.component';
import {ImportResultDialogComponent as RedirectionImportResultDialog} from './modules/settlements/redirections/import-result-dialog/import-result-dialog.component';
import { ChangeRatePaidDialogComponent } from './modules/settlements/redirections/change-rate-paid-dialog/change-rate-paid-dialog.component';
import { AddStatementDialogComponent } from './modules/idd-trainings/add-statement-dialog/add-statement-dialog.component';
import {OrderIddCertificatesPipe} from './shared/pipe/order-idd-certificates';
import { AddThresholdComponent } from './modules/settlements/thresholds/add-threshold/add-threshold.component';
import { AllThresholdsListComponent } from './modules/settlements/thresholds/all-thresholds-list/all-thresholds-list.component';
import { EditThresholdModalComponent } from './modules/settlements/thresholds/edit-threshold-modal/edit-threshold-modal.component';
import { ThresholdGroupFormComponent } from './modules/settlements/thresholds/threshold-group-form/threshold-group-form.component';
import { ThresholdGroupViewComponent } from './modules/settlements/thresholds/threshold-group-view/threshold-group-view.component';
import { AddAnnexComponent } from './modules/settlements/annexes/add-annex/add-annex.component';
import { AllAnnexesListComponent } from './modules/settlements/annexes/all-annexes-list/all-annexes-list.component';
import { EditAnnexModalComponent } from './modules/settlements/annexes/edit-annex-modal/edit-annex-modal.component';
import { AnnexGroupFormComponent } from './modules/settlements/annexes/annex-group-form/annex-group-form.component';
import { AnnexGroupViewComponent } from './modules/settlements/annexes/annex-group-view/annex-group-view.component';
import { DictThresholdsComponent } from './shared/components/dict-thresholds/dict-thresholds.component';
import { UpdateCurrentDynamicsDialogComponent } from './modules/partners/update-current-dynamics-dialog/update-current-dynamics-dialog.component';
import { AddRiskDictComponent } from './modules/settlements/risk-dicts/add-risk-dict/add-risk-dict.component';
import { AllRiskDictsListComponent } from './modules/settlements/risk-dicts/all-risk-dicts-list/all-risk-dicts-list.component';
import { EditRiskDictModalComponent } from './modules/settlements/risk-dicts/edit-risk-dict-modal/edit-risk-dict-modal.component';
import { RiskDictGroupFormComponent } from './modules/settlements/risk-dicts/risk-dict-group-form/risk-dict-group-form.component';
import { RiskDictGroupViewComponent } from './modules/settlements/risk-dicts/risk-dict-group-view/risk-dict-group-view.component';
import { DictRiskDictsComponent } from './shared/components/dict-risk-dicts/dict-risk-dicts.component';
import {SplitPipe} from "./shared/pipe/split";
import { ContractOfwcaApplicationsListComponent } from './modules/contracts/contract-ofwca-applications-list/contract-ofwca-applications-list.component';
import { OfwcasListDialogComponent } from './modules/ofwcas/ofwcas-list-dialog/ofwcas-list-dialog.component';
import { ContractInsuranceCompaniesSelectDialogComponent } from './modules/contracts/contract-insurance-companies-select-dialog/contract-insurance-companies-select-dialog.component';
import { CrossCompanyReportDialogComponent } from './modules/settlements/redirections/cross-company-report-dialog/cross-company-report-dialog.component';
import { MassEditionComponent } from './modules/settlements/mass-edition/mass-edition.component';
import { MassEditionDialogComponent } from './modules/settlements/mass-edition-dialog/mass-edition-dialog.component';
import { AllInvoicesListComponent } from './modules/settlements/invoices/all-invoices-list/all-invoices-list.component';
import { AddInvoiceComponent } from './modules/settlements/invoices/add-invoice/add-invoice.component';
import { InvoiceDetailsComponent } from './modules/settlements/invoices/invoice-details/invoice-details.component';
import { InvoiceDetailsViewComponent } from './modules/settlements/invoices/invoice-details-view/invoice-details-view.component';
import { ChangeStatusDialogComponent } from './modules/settlements/invoices/change-status-dialog/change-status-dialog.component';
import { CreateDocumentDialogComponent } from './modules/settlements/invoices/create-document-dialog/create-document-dialog.component';
import {AngularEditorModule} from '@kolkov/angular-editor';
import { TemplateComponent } from './modules/settlements/template/template.component';
import { AllPaymentListComponent } from './modules/settlements/payment/all-payment-list/all-payment-list.component';
import { PaymentHistoryComponent } from './modules/settlements/payment/payment-history/payment-history.component';
import { DictCommissionSettlementComponent } from './shared/components/dict-commission-settlement/dict-commission-settlement.component';
import { DictIddTrainingTrainerComponent } from './shared/components/dict-idd-training-trainer/dict-idd-training-trainer.component';
import { AddInitialBalanceComponent } from './modules/settlements/invoices/add-initial-balance/add-initial-balance.component';
import { AllCommissionsListInvoicesComponent } from './modules/settlements/imports/all-commissions-list-invoices/all-commissions-list-invoices.component';
import { SubmissionsComponent } from './modules/submissions/submissions.component';
import { NewsletterListComponent } from './modules/newsletter/newsletter-list/newsletter-list.component';
import { NewsletterDetailsComponent } from './modules/newsletter/newsletter-details/newsletter-details.component';
import { NewsletterDetailsViewComponent } from './modules/newsletter/newsletter-details-view/newsletter-details-view.component';
import { NewsletterCurrentComponent } from './modules/newsletter/newsletter-current/newsletter-current.component';
import { NewsletterAddComponent } from './modules/newsletter/newsletter-add/newsletter-add.component';
import {NgxExtendedPdfViewerModule} from "ngx-extended-pdf-viewer";
import { NewsletterPdfViewComponent } from './modules/newsletter/newsletter-pdf-view/newsletter-pdf-view.component';
import { JobsListDialogComponent } from './modules/settlements/jobs-list-dialog/jobs-list-dialog.component';
import { AllRegionalListComponent } from './modules/regional/all-regional-list/all-regional-list.component';
import { RegionalDetailsComponent } from './modules/regional/regional-details/regional-details.component';
import { RegionalDetailsViewComponent } from './modules/regional/regional-details-view/regional-details-view.component';
import { RegionalAddComponent } from './modules/regional/regional-add/regional-add.component';
import { ReportCustomComponent } from './modules/report-custom/report-custom.component';
import { AddInsuranceCompanyComponent } from './modules/insurance-companies/add-insurance-company/add-insurance-company.component';
import { ChangeAccountNumberDialogComponent } from './modules/partners/change-account-number-dialog/change-account-number-dialog.component';
import { OfwcaChangeAccountNumberDialogComponent } from './modules/ofwcas/ofwca-change-account-number-dialog/ofwca-change-account-number-dialog.component';
import { EditInvoiceComponent } from './modules/settlements/invoices/edit-invoice/edit-invoice.component';
import { RegistrationsAddMultipleComponent } from './modules/registrations/registrations-add-multiple/registrations-add-multiple.component';
import { RegistrationsAddMultipleDialogComponent } from './modules/registrations/registrations-add-multiple-dialog/registrations-add-multiple-dialog.component';
import { AllSupportListComponent } from './modules/support/all-support-list/all-support-list.component';
import { SupportAddComponent } from './modules/support/support-add/support-add.component';
import { SupportDetailsComponent } from './modules/support/support-details/support-details.component';
import { SupportDetailsViewComponent } from './modules/support/support-details-view/support-details-view.component';
import { AllLicensedAgentComponent } from './modules/agent-21/all-licensed-agent/all-licensed-agent.component';
import { AllContractBalanceListComponent } from './modules/settlements/contract-balance/all-contract-balance-list/all-contract-balance-list.component';
import { ContractBalanceDetailsComponent } from './modules/settlements/contract-balance/contract-balance-details/contract-balance-details.component';
import { ContractBalanceDetailsViewComponent } from './modules/settlements/contract-balance/contract-balance-details-view/contract-balance-details-view.component';
import { ContractInitialBalanceDetailsViewComponent } from './modules/settlements/contract-balance/contract-initial-balance-details-view/contract-initial-balance-details-view.component';
import { ReportPartnersComponent } from './modules/analytics/report-partners/report-partners.component';
import { ReportOfwcasComponent } from './modules/analytics/report-ofwcas/report-ofwcas.component';
import { ReportContractsComponent } from './modules/analytics/report-contracts/report-contracts.component';
import { ReportRegistrationsComponent } from './modules/analytics/report-registrations/report-registrations.component';
import { ReportIdentifiersComponent } from './modules/analytics/report-identifiers/report-identifiers.component';
import { ReportRedirectionComponent } from './modules/analytics/report-redirection/report-redirection.component';
import { SearchEngineComponent } from './modules/partners/search-engine/search-engine.component';
import { OfwcaRegisteredListComponent } from './modules/meetings/ofwca-registered-list/ofwca-registered-list.component';
import { AddSettlementsTemplateComponent } from './modules/settlements/settlemnts-tempate/add-settlements-template/add-settlements-template.component';
import { AllSettlementsTemplateListComponent } from './modules/settlements/settlemnts-tempate/all-settlements-template-list/all-settlements-template-list.component';
import { SettlementsTemplateComponent } from './modules/settlements/settlemnts-tempate/settlements-template/settlements-template.component';
import { SettlementsTemplateViewComponent } from './modules/settlements/settlemnts-tempate/settlements-template-view/settlements-template-view.component';
import { AddSettlementsTemplateDialogComponent } from './modules/settlements/settlemnts-tempate/add-settlements-template-dialog/add-settlements-template-dialog.component';
import { SendMailDialogComponent } from './shared/components/send-mail-dialog/send-mail-dialog.component';
import { AddBillsComponent } from './modules/settlements/invoices/add-bills/add-bills.component';
import { BillsFileDragAndDropComponent } from './shared/components/bills-file-drag-and-drop/bills-file-drag-and-drop.component';
import { LoginLogListComponent } from './modules/login-log/login-log-list/login-log-list.component';
import { DictOfwcasPartnersComponent } from './shared/components/dict-ofwcas-partners/dict-ofwcas-partners.component';
import { ContractInvoiceNumberEditComponent } from './modules/contracts/contract-invoice-number-edit/contract-invoice-number-edit.component';
import { TuTemplateComponent } from './modules/identifiers/tu-template/tu-template.component';
import { CrmUserPermissionsListComponent } from './modules/user/crm-user-permissions-list/crm-user-permissions-list.component';
import { CrmUserPermissionsAddComponent } from './modules/user/crm-user-permissions-add/crm-user-permissions-add.component';
import { OfwcaChangeHiperioDataComponent } from './modules/ofwcas/ofwca-change-hiperio-data/ofwca-change-hiperio-data.component';
import { AllFacilitiesVerificationSalesProcessListComponent } from './modules/facilities/all-facilities-verification-sales-process-list/all-facilities-verification-sales-process-list.component';
import { FacilitiesVerificationSalesProcessAddComponent } from './modules/facilities/facilities-verification-sales-process-add/facilities-verification-sales-process-add.component';
import { VerificationSalesProcessViewComponent } from './modules/facilities/verification-sales-process-view/verification-sales-process-view.component';
import { AllBankFilesListComponent } from './modules/bank-files/all-bank-files-list/all-bank-files-list.component';
import { CommissionMarginReportListComponent } from './modules/settlements/commission-margin-report/commission-margin-report-list/commission-margin-report-list.component';
import { AllCorporationListComponent } from './modules/corporation/all-corporation-list/all-corporation-list.component';
import { CorporationAddComponent } from './modules/corporation/corporation-add/corporation-add.component';
import { CorporationDetailsComponent } from './modules/corporation/corporation-details/corporation-details.component';
import { CorporationDetailsViewComponent } from './modules/corporation/corporation-details-view/corporation-details-view.component';
import { AllPostListComponent } from './modules/asf360/post/all-post-list/all-post-list.component';
import { PostAddComponent } from './modules/asf360/post/post-add/post-add.component';
import { PostDetailsComponent } from './modules/asf360/post/post-details/post-details.component';
import { PostDetailsViewComponent } from './modules/asf360/post/post-details-view/post-details-view.component';
import { AllTagsListComponent } from './modules/asf360/tags/all-tags-list/all-tags-list.component';
import { TagsAddComponent } from './modules/asf360/tags/tags-add/tags-add.component';
import { DictTagComponent } from './shared/components/dict-tag/dict-tag.component';
import { AllPermissionTagsListComponent } from './modules/asf360/permission-tags/all-permission-tags-list/all-permission-tags-list.component';
import { PermissionTagsAddComponent } from './modules/asf360/permission-tags/permission-tags-add/permission-tags-add.component';
import { DictPermissionTagsComponent } from './shared/components/dict-permission-tags/dict-permission-tags.component';
import { PermissionTagsDetailsComponent } from './modules/asf360/permission-tags/permission-tags-details/permission-tags-details.component';
import { PermissionTagsDetailsViewComponent } from './modules/asf360/permission-tags/permission-tags-details-view/permission-tags-details-view.component';
import { AddPermissionTagUserComponent } from './modules/asf360/permission-tags/add-permission-tag-user/add-permission-tag-user.component';
import { AllSelfBillingFormListComponent } from './modules/self-billing-form/all-self-billing-form-list/all-self-billing-form-list.component';
import { AddressImportComponent } from './modules/address-imports/address-import/address-import.component';
import { AllAddressImportComponent } from './modules/address-imports/all-address-import/all-address-import.component';
import { AllAddressImportRowComponent } from './modules/address-imports/all-address-import-row/all-address-import-row.component';
import { DictAddressComponent } from './shared/components/dict-address/dict-address.component';
import { TagsDetailsComponent } from './modules/asf360/tags/tags-details/tags-details.component';
import { TagsDetailsViewComponent } from './modules/asf360/tags/tags-details-view/tags-details-view.component';
import { UsersDialogComponent } from './shared/components/users-dialog/users-dialog.component';
import {DragDropModule} from "@angular/cdk/drag-drop";
import { OckAddComponent } from './modules/partners/ock-add/ock-add.component';
import { DocumentPreviewComponent } from './shared/components/document-preview/document-preview.component';
import { DynamicDictComponent } from './shared/components/dynamic-dict/dynamic-dict.component';
import { AllDynamicDictionaryListComponent } from './modules/dynamic-dictionary/all-dynamic-dictionary-list/all-dynamic-dictionary-list.component';
import { DynamicDictionaryAddComponent } from './modules/dynamic-dictionary/dynamic-dictionary-add/dynamic-dictionary-add.component';
import { DynamicDictionaryDetailsComponent } from './modules/dynamic-dictionary/dynamic-dictionary-details/dynamic-dictionary-details.component';
import { DynamicDictionaryDetailsViewComponent } from './modules/dynamic-dictionary/dynamic-dictionary-details-view/dynamic-dictionary-details-view.component';
import { CalendarComponent } from './modules/meetings/calendar/calendar.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MeetingDetailsViewDialogComponent } from './modules/meetings/meeting-details-view-dialog/meeting-details-view-dialog.component';
import { MeetingAddDialogComponent } from './modules/meetings/meeting-add-dialog/meeting-add-dialog.component';
import { AddressAddComponent } from './modules/address-imports/address-add/address-add.component';
import { CalendarDialogComponent } from './modules/meetings/calendar-dialog/calendar-dialog.component';
import { CalendarEventComponent } from './modules/meetings/calendar-event/calendar-event.component';
import { OfwcasMissingDocumentsComponent } from './modules/ofwcas/ofwcas-missing-documents/ofwcas-missing-documents.component';
import { ReportListComponent } from './modules/analytics/report-list/report-list.component';
import { PermissionTagsUserImportComponent } from './modules/asf360/permission-tags/permission-tags-user-import/permission-tags-user-import.component';
import { AddDynamicFormComponent } from './modules/dynamic-forms/add-dynamic-form/add-dynamic-form.component';
import { DynamicFormListComponent } from './modules/dynamic-forms/dynamic-form-list/dynamic-form-list.component';
import { DynamicFormsDetailsComponent } from './modules/dynamic-forms/dynamic-forms-details/dynamic-forms-details.component';
import { DynamicFormsDetailsViewComponent } from './modules/dynamic-forms/dynamic-forms-details-view/dynamic-forms-details-view.component';
import { DynamicFormApplyListComponent } from './modules/dynamic-forms/dynamic-form-apply-list/dynamic-form-apply-list.component';
import { DynamicFormViewComponent } from './modules/dynamic-forms/dynamic-form-view/dynamic-form-view.component';
import { ReceivablesImportComponent } from './modules/receivables/imports/receivables-import/receivables-import.component';
import { AllReceivablesImportsListComponent } from './modules/receivables/imports/all-receivables-imports-list/all-receivables-imports-list.component';
import { AllReceivablesImportsRowListComponent } from './modules/receivables/imports-row/all-receivables-imports-row-list/all-receivables-imports-row-list.component';
import { ReceivablesImportsRowDetailsComponent } from './modules/receivables/imports-row/receivables-imports-row-details/receivables-imports-row-details.component';
import { ReceivablesImportsRowDetailsViewComponent } from './modules/receivables/imports-row/receivables-imports-row-details-view/receivables-imports-row-details-view.component';
import { ReceivablesJobListComponent } from './modules/receivables/generat/receivables-job-list/receivables-job-list.component';
import { ChangeRegistrationDialogComponent } from './modules/receivables/imports-row/change-registration-dialog/change-registration-dialog.component';
import { AllReceivablesStatementListComponent } from './modules/receivables/statement/all-receivables-statement-list/all-receivables-statement-list.component';
import { StatementAddComponent } from './modules/receivables/statement/statement-add/statement-add.component';
import { ReceivablesStatementDetailsComponent } from './modules/receivables/statement/receivables-statement-details/receivables-statement-details.component';
import { ReceivablesStatementDetailsViewComponent } from './modules/receivables/statement/receivables-statement-details-view/receivables-statement-details-view.component';
import { ReceivablesImportsRowListComponent } from './modules/receivables/imports-row/receivables-imports-row-list/receivables-imports-row-list.component';
import { AddEmailToFormDialogComponent } from './modules/dynamic-forms/add-email-to-form-dialog/add-email-to-form-dialog.component';
import { AddPartnerToFormDialogComponent } from './modules/dynamic-forms/add-partner-to-form-dialog/add-partner-to-form-dialog.component';
import { ChangeFormRowStatusDialogComponent } from './modules/dynamic-forms/change-form-row-status-dialog/change-form-row-status-dialog.component';
import { AllReceivablesBalanceListComponent } from './modules/receivables/balance/all-receivables-balance-list/all-receivables-balance-list.component';
import { ReceivablesPaymentImportComponent } from './modules/receivables/payment/receivables-payment-import/receivables-payment-import.component';
import { AllReceivablesPaymentImportListComponent } from './modules/receivables/payment/all-receivables-payment-import-list/all-receivables-payment-import-list.component';
import { AllReceivablesPaymentImportRowListComponent } from './modules/receivables/payment/all-receivables-payment-import-row-list/all-receivables-payment-import-row-list.component';
import { ReceivablesPaymentImportRowDetailsComponent } from './modules/receivables/payment/receivables-payment-import-row-details/receivables-payment-import-row-details.component';
import { ReceivablesPaymentImportRowDetailsViewComponent } from './modules/receivables/payment/receivables-payment-import-row-details-view/receivables-payment-import-row-details-view.component';
import { ChangeStatementDialogComponent } from './modules/receivables/payment/change-statement-dialog/change-statement-dialog.component';
import { ReceivablesBalanceDetailsComponent } from './modules/receivables/balance/receivables-balance-details/receivables-balance-details.component';
import { ReceivablesBalanceDetailsViewComponent } from './modules/receivables/balance/receivables-balance-details-view/receivables-balance-details-view.component';
import { StatementAddDialogComponent } from './modules/receivables/statement/statement-add-dialog/statement-add-dialog.component';
import { ReceivablesPaymentImportAddComponent } from './modules/receivables/payment/receivables-payment-import-add/receivables-payment-import-add.component';
import { RegistrationIdentifiersComponent } from './modules/registrations/registration-identifiers/registration-identifiers.component';
import { RegistrationIdentifiersFormComponent } from './modules/registrations/registration-identifiers-form/registration-identifiers-form.component';
import { AllReceivablesBalanceHistoryListComponent } from './modules/receivables/balance/all-receivables-balance-history-list/all-receivables-balance-history-list.component';
import { ReceivablesBalanceAddDialogComponent } from './modules/receivables/balance/receivables-balance-add-dialog/receivables-balance-add-dialog.component';
import { DictReceivablesBalanceComponent } from './shared/components/dict-receivables-balance/dict-receivables-balance.component';
import { PolicyOverrideDialogComponent } from './modules/receivables/imports-row/policy-override-dialog/policy-override-dialog.component';
import { CloneAnnexesDialogComponent } from './shared/components/clone-annexes-dialog/clone-annexes-dialog.component';
import { EmailSendAddComponent } from './modules/email-send/email-send-add/email-send-add.component';
import { EmailSendJobListComponent } from './modules/email-send/email-send-job-list/email-send-job-list.component';
import { EmailSendDetailsComponent } from './modules/email-send/email-send-details/email-send-details.component';
import { EmailSendDetailsViewComponent } from './modules/email-send/email-send-details-view/email-send-details-view.component';
import { ReceivablesPaymentImportRowAddComponent } from './modules/receivables/payment/receivables-payment-import-row-add/receivables-payment-import-row-add.component';
import {ProductContactPipe} from "./shared/pipe/product-contact";
import { IddTrainingsTrainerListComponent } from './modules/idd-trainings/idd-trainings-trainer-list/idd-trainings-trainer-list.component';
import { AddIddTrainingsTrainerComponent } from './modules/idd-trainings/add-idd-trainings-trainer/add-idd-trainings-trainer.component';
import { IddTrainingsTrainerDetailsComponent } from './modules/idd-trainings/idd-trainings-trainer-details/idd-trainings-trainer-details.component';
import { IddTrainingsTrainerDetailsViewComponent } from './modules/idd-trainings/idd-trainings-trainer-details-view/idd-trainings-trainer-details-view.component';
import {AllNoteListComponent} from "./modules/note/all-note-list/all-note-list.component";
import {NoteListComponent} from "./modules/note/note-list/note-list.component";
import {NoteAddComponent} from "./modules/note/note-add/note-add.component";
import {NoteAddDialogComponent} from './modules/note/note-add-dialog/note-add-dialog.component';
import {NoteDetailsComponent} from "./modules/note/note-details/note-details.component";
import {NoteDetailsViewComponent} from "./modules/note/note-details-view/note-details-view.component";
import { OfwcaRejectedCommissionAddComponent } from './modules/ofwcas/ofwca-rejected-commission-add/ofwca-rejected-commission-add.component';
import { CancelRegistrationDialogComponent } from './modules/registrations/cancel-registration-dialog/cancel-registration-dialog.component';
import { OckCompanyListComponent } from './modules/ock/ock-company-list/ock-company-list.component';
import { OckPolicyListComponent } from './modules/ock/ock-policy-list/ock-policy-list.component';
import { OckUserListComponent } from './modules/ock/ock-user-list/ock-user-list.component';
import { OckImportComponent } from './modules/ock/ock-import/ock-import.component';
import { AllOckImportListComponent } from './modules/ock/all-ock-import-list/all-ock-import-list.component';
import { AllNipListComponent } from './modules/ock/all-nip-list/all-nip-list.component';
import { AllVinListComponent } from './modules/ock/all-vin-list/all-vin-list.component';
import { NipAddComponent } from './modules/ock/nip-add/nip-add.component';
import { VinAddComponent } from './modules/ock/vin-add/vin-add.component';
import { CommissionUpdatePackageListComponent } from './modules/settlements/commission-update-package/commission-update-package-list/commission-update-package-list.component';
import { CommissionUpdatePackageDetailsComponent } from './modules/settlements/commission-update-package/commission-update-package-details/commission-update-package-details.component';
import { CommissionUpdatePackageViewComponent } from './modules/settlements/commission-update-package/commission-update-package-view/commission-update-package-view.component';
import { CommissionUpdatePackageAddComponent } from './modules/settlements/commission-update-package/commission-update-package-add/commission-update-package-add.component';
import { AllTerminalsListComponent } from './modules/terminals/all-terminals-list/all-terminals-list.component';
import { AddTerminalDialogComponent } from './modules/terminals/add-terminal-dialog/add-terminal-dialog.component';
import { AddLicensedComponent } from './modules/agent-21/add-licensed/add-licensed.component';
import { LicensedDetailsComponent } from './modules/agent-21/licensed-details/licensed-details.component';
import { LicensedDetailsViewComponent } from './modules/agent-21/licensed-details-view/licensed-details-view.component';
import { LicensedDetailsFormComponent } from './modules/agent-21/licensed-details-form/licensed-details-form.component';
import { TerminalsDetailsComponent } from './modules/terminals/terminals-details/terminals-details.component';
import { TerminalsDetailsViewComponent } from './modules/terminals/terminals-details-view/terminals-details-view.component';
import { AllTerminalsImportsListComponent } from './modules/terminals/imports/all-terminals-imports-list/all-terminals-imports-list.component';
import { TerminalsImportComponent } from './modules/terminals/imports/terminals-import/terminals-import.component';
import { AllTerminalsImportsRowListComponent } from './modules/terminals/imports-row/all-terminals-imports-row-list/all-terminals-imports-row-list.component';
import { TerminalsImportsRowDetailsComponent } from './modules/terminals/imports-row/terminals-imports-row-details/terminals-imports-row-details.component';
import { TerminalsImportsRowDetailsViewComponent } from './modules/terminals/imports-row/terminals-imports-row-details-view/terminals-imports-row-details-view.component';
import { TerminalsBankJobListComponent } from './modules/terminals/bankJob/terminals-bank-job-list/terminals-bank-job-list.component';
import { ChangePartnerFacilityDialogComponent } from './modules/terminals/imports-row/change-partner-facility-dialog/change-partner-facility-dialog.component';
import { ChangeTerminalsImportRowDialogComponent } from './modules/terminals/change-terminals-import-row-dialog/change-terminals-import-row-dialog.component';
import { DictTerminalImportRowComponent } from './shared/components/dict-terminal-import-row/dict-terminal-import-row.component';
import { TerminalsDetailsFormComponent } from './modules/terminals/terminals-details-form/terminals-details-form.component';
import { AffiliateCodeListComponent } from './modules/affiliate-code/affiliate-code-list/affiliate-code-list.component';
import { AffiliateCodeAddDialogComponent } from './modules/affiliate-code/affiliate-code-add-dialog/affiliate-code-add-dialog.component';
import { AffiliateCodeDetailsComponent } from './modules/affiliate-code/affiliate-code-details/affiliate-code-details.component';
import { AffiliateCodeDetailsViewComponent } from './modules/affiliate-code/affiliate-code-details-view/affiliate-code-details-view.component';
import { FileManagerListComponent } from './modules/file-manager/file-manager-list/file-manager-list.component';
import { AddCatalogDialogComponent } from './modules/file-manager/add-catalog-dialog/add-catalog-dialog.component';
import { AddFileDialogComponent } from './modules/file-manager/add-file-dialog/add-file-dialog.component';
import { TagAddComponent } from './modules/file-manager/tag/tag-add/tag-add.component';
import { AllTagListComponent } from './modules/file-manager/tag/all-tag-list/all-tag-list.component';
import { DictTagFileManagerComponent } from './shared/components/dict-tag-file-manager/dict-tag-file-manager.component';
import { AllSharedFileListComponent } from './modules/file-manager/shared-file/all-shared-file-list/all-shared-file-list.component';
import { SharedFileAddComponent } from './modules/file-manager/shared-file/shared-file-add/shared-file-add.component';
import { AddPageComponent } from './modules/file-manager/page/add-page/add-page.component';
import { PageListComponent } from './modules/file-manager/page/page-list/page-list.component';
import { PageDetailsComponent } from './modules/file-manager/page/page-details/page-details.component';
import { PageDetailsViewComponent } from './modules/file-manager/page/page-details-view/page-details-view.component';
import { DictPageFileManagerComponent } from './shared/components/dict-page-file-manager/dict-page-file-manager.component';
import { ReceivablesBalanceUpdateOfwcaComponent } from './modules/receivables/balance/receivables-balance-update-ofwca/receivables-balance-update-ofwca.component';
import { ReceivablesBalanceUpdatePartnerFacilityComponent } from './modules/receivables/balance/receivables-balance-update-partner-facility/receivables-balance-update-partner-facility.component';
import { AllPersonalDataChangeListComponent } from './modules/personal-data-change/all-personal-data-change-list/all-personal-data-change-list.component';
import { PersonalDataChangeDetailsViewComponent } from './modules/personal-data-change/personal-data-change-details-view/personal-data-change-details-view.component';
import { PersonalDataChangeDetailsComponent } from "./modules/personal-data-change/personal-data-change-details/personal-data-change-details.component";
import { ChroniePaymentListComponent } from './modules/chronie/chronie-payment-list/chronie-payment-list.component';
import { ChronieJobListComponent } from './modules/chronie/chronie-job-list/chronie-job-list.component';
import { IssueInsurancePolicyChronieDialogComponent } from './shared/components/issue-insurance-policy-chronie-dialog/issue-insurance-policy-chronie-dialog.component';
import { TransferBankJobListComponent } from './modules/receivables/transfer/transfer-bank-job-list/transfer-bank-job-list.component';
import { TransferDetailsComponent } from './modules/receivables/transfer/transfer-details/transfer-details.component';
import { TransferDetailsViewComponent } from './modules/receivables/transfer/transfer-details-view/transfer-details-view.component';
import { TransferListComponent } from './modules/receivables/transfer/transfer-list/transfer-list.component';
import { TransferAddComponent } from './modules/receivables/transfer/transfer-add/transfer-add.component';
import { AllCommissionImportRowSettledListComponent } from './modules/settlements/commission-import-row-settled/all-commission-import-row-settled-list/all-commission-import-row-settled-list.component';
import { ConfirmDialogWithDictComponent } from './shared/components/confirm-dialog-with-dict/confirm-dialog-with-dict.component';
import { DictDobryAgentPartnersComponent } from './shared/components/dict-dobry-agent-partners/dict-dobry-agent-partners.component';
import { AllBlockedNipListComponent } from './modules/partners/all-blocked-nip-list/all-blocked-nip-list.component';
import { BlockedNipAddDialogComponent } from './modules/partners/blocked-nip-add-dialog/blocked-nip-add-dialog.component';
import { BlockedNipAddComponent } from './modules/partners/blocked-nip-add/blocked-nip-add.component';
import { ApplicationsComponent } from './modules/forms/applications/applications.component';
import { AllIddTrainingCertificatesToCheckListComponent } from './modules/idd-trainings/all-idd-training-certificates-to-check-list/all-idd-training-certificates-to-check-list.component';
import { IddCertificateEditDialogComponent } from './modules/idd-trainings/idd-certificate-edit-dialog/idd-certificate-edit-dialog.component';
import { DenyIddCertificateDialogComponent } from './modules/idd-trainings/deny-idd-certificate-dialog/deny-idd-certificate-dialog.component';
import { AllEmployeeListComponent } from './modules/hr/employee/all-employee-list/all-employee-list.component';
import { EmployeeDetailsComponent } from './modules/hr/employee/employee-details/employee-details.component';
import { EmployeeDetailsViewComponent } from './modules/hr/employee/employee-details-view/employee-details-view.component';
import { LeaveApplicationAddDialogComponent } from './modules/hr/leave/leave-application-add-dialog/leave-application-add-dialog.component';
import { LeaveApplicationListComponent } from './modules/hr/leave/leave-application-list/leave-application-list.component';
import { LeaveApplicationDetailsComponent } from './modules/hr/leave/leave-application-details/leave-application-details.component';
import { LeaveApplicationDetailsViewComponent } from './modules/hr/leave/leave-application-details-view/leave-application-details-view.component';
import { EmployeeDetailsFormComponent } from './modules/hr/employee/employee-details-form/employee-details-form.component';
import { AllLeaveApplicationListComponent } from './modules/hr/leave/all-leave-application-list/all-leave-application-list.component';
import { LeaveApplicationAddFileComponent } from './modules/hr/leave/leave-application-add-file/leave-application-add-file.component';
import { ReceivablesBalanceNoteAddComponent } from './modules/receivables/balance/receivables-balance-note-add/receivables-balance-note-add.component';
import { ReceivablesBalanceNoteListComponent } from './modules/receivables/balance/receivables-balance-note-list/receivables-balance-note-list.component';
import { ChangeStatusReceivablesImportsRowDialogComponent } from './modules/receivables/imports-row/change-status-receivables-imports-row-dialog/change-status-receivables-imports-row-dialog.component';
import { LeaveApplicationEditComponent } from './modules/hr/leave/leave-application-edit/leave-application-edit.component';
import { LicenseAddComponent } from './modules/license/license-add/license-add.component';
import { LicenseAddDialogComponent } from './modules/license/license-add-dialog/license-add-dialog.component';
import { LicenseDetailsComponent } from './modules/license/license-details/license-details.component';
import { LicenseDetailsViewComponent } from './modules/license/license-details-view/license-details-view.component';
import {AllLicenseListComponent} from "./modules/license/all-license-list/all-license-list.component";
import { UserLicensesDetailsComponent } from './modules/license/user-licenses-details/user-licenses-details.component';
import { UserLicensesDetailsViewComponent } from './modules/license/user-licenses-details-view/user-licenses-details-view.component';
import { DeviceAddComponent } from './modules/license/device-add/device-add.component';
import { DeviceAddDialogComponent } from './modules/license/device-add-dialog/device-add-dialog.component';
import { AllDeviceListComponent } from './modules/license/all-device-list/all-device-list.component';
import { DictUserDevicesComponent } from './shared/components/dict-user-devices/dict-user-devices.component';
import { DeviceDetailsComponent } from './modules/license/device-details/device-details.component';
import { DeviceDetailsViewComponent } from './modules/license/device-details-view/device-details-view.component';
import {
  WarehouseProductDetailsViewComponent
} from "./modules/warehouse/warehouse-product-details-view/warehouse-product-details-view.component";
import {
  WarehouseProductAddDialogComponent
} from "./modules/warehouse/warehouse-product-add-dialog/warehouse-product-add-dialog.component";
import {
  WarehouseProductAddComponent
} from "./modules/warehouse/warehouse-product-add/warehouse-product-add.component";
import {
  AllWarehouseProductListComponent
} from "./modules/warehouse/all-warehouse-product-list/all-warehouse-product-list.component";
import {
  WarehouseProductDetailsComponent
} from "./modules/warehouse/warehouse-product-details/warehouse-product-details.component";
import { CompetitionDataImportComponent } from './modules/competition-import/competition-data-import/competition-data-import.component';
import { AdditionalFieldsListComponent } from './modules/additional-fields/additional-fields-list/additional-fields-list.component';
import { AdditionalFieldsAddComponent } from './modules/additional-fields/additional-fields-add/additional-fields-add.component';
import { AdditionalFieldsAddDialogComponent } from './modules/additional-fields/additional-fields-add-dialog/additional-fields-add-dialog.component';
import { CompetitionImportListComponent } from './modules/competition-import/competition-import-list/competition-import-list.component';
import {
  DictAdditionalFieldsComponent
} from "./shared/components/dict-additional-fields/dict-additional-fields.component";
import { AdditionalFieldsDetailsComponent } from './modules/additional-fields/additional-fields-details/additional-fields-details.component';
import { AdditionalFieldsDetailsViewComponent } from './modules/additional-fields/additional-fields-details-view/additional-fields-details-view.component';
import { CompetitionListComponent } from './modules/competition-import/competition-list/competition-list.component';
import { CompetitionImportValuesListComponent } from './modules/competition-import/competition-import-values-list/competition-import-values-list.component';
import {
  CompetitionImportRowDetailsViewComponent
} from "./modules/competition-import/competition-import-row-details-view/competition-import-row-details-view.component";
import {
  CompetitionImportRowDetailsComponent
} from "./modules/competition-import/competition-import-row-details/competition-import-row-details.component";
import {
  CompetitionImportRowListComponent
} from "./modules/competition-import/competition-import-row-list/competition-import-row-list.component";
import { EditCompetitionImportRowComponent } from './modules/competition-import/edit-competition-import-row/edit-competition-import-row.component';
import { EditDialogCompetitionImportRowComponent } from './modules/competition-import/edit-dialog-competition-import-row/edit-dialog-competition-import-row.component';
import { DictWarehouseProductsComponent } from './shared/components/dict-warehouse-products/dict-warehouse-products.component';
import { ReceivablesPaymentImportTransferAddComponent } from './modules/receivables/payment/receivables-payment-import-transfer-add/receivables-payment-import-transfer-add.component';
import {CompetitionWzListComponent} from "./modules/competition-wz/competition-wz-list/competition-wz-list.component";
import {
  CompetitionWzRowsListComponent
} from "./modules/competition-wz/competition-wz-rows-list/competition-wz-rows-list.component";
import { LogDeletedDataListComponent } from './modules/log-deleted-data/log-deleted-data-list/log-deleted-data-list.component';
import { TerminalsNoteAddComponent } from './modules/terminals/terminals-note-add/terminals-note-add.component';
import { HiperioRegistrationConfigComponent } from './modules/agents-profile-hiperio/hiperio-registration-config/hiperio-registration-config.component';
import { HiperioRegistrationConfigDetailsComponent } from './modules/agents-profile-hiperio/hiperio-registration-config-details/hiperio-registration-config-details.component';
import { HiperioRegistrationConfigDetailsViewComponent } from './modules/agents-profile-hiperio/hiperio-registration-config-details-view/hiperio-registration-config-details-view.component';
import { ChangeRegistrationHiperioDialogComponent } from "./modules/agents-profile-hiperio/change-registration-dialog/change-registration-hiperio-dialog.component";
import { ChangeParameterDialogComponent } from './modules/agents-profile-hiperio/change-parameter-dialog/change-parameter-dialog.component';
import { UserJobsListComponent } from './modules/agents-profile-hiperio/user-jobs-list/user-jobs-list.component';
import { CredentialsJobsListComponent } from './modules/agents-profile-hiperio/credentials-jobs-list/credentials-jobs-list.component';
import { HiperioTestAccessFormListComponent } from './modules/agents-profile-hiperio/hiperio-test-access-form-list/hiperio-test-access-form-list.component';
import { FacilityDobryAgentSelectComponent } from './shared/components/facility-dobry-agent-select/facility-dobry-agent-select.component';
import { FacilityDobryAgentViewComponent } from './modules/facilities/facility-dobry-agent-view/facility-dobry-agent-view.component';
import { ApplicationPermissionComponent } from './modules/forms/application-permission/application-permission.component';
import { FacilityDobryAgentAddComponent } from './modules/facilities/facility-dobry-agent-add/facility-dobry-agent-add.component';
import { DictDobryAgentSelectComponent } from './shared/components/dict-dobry-agent-select/dict-dobry-agent-select.component';
import { InsuranceCompanyDobryAgentSelectComponent } from './shared/components/insurance-company-dobry-agent-select/insurance-company-dobry-agent-select.component';
import { CityDobryAgentSelectComponent } from './shared/components/city-dobry-agent-select/city-dobry-agent-select.component';
import { PaymentMethodDobryAgentSelectComponent } from './shared/components/payment-method-dobry-agent-select/payment-method-dobry-agent-select.component';
import { SubCategoryDobryAgentSelectComponent } from './shared/components/sub-category-dobry-agent-select/sub-category-dobry-agent-select.component';
import { AffiliateCodeSelectComponent } from './shared/components/affiliate-code-select/affiliate-code-select.component';
import { GooglePlaceDobryAgentSelectComponent } from './shared/components/google-place-dobry-agent-select/google-place-dobry-agent-select.component';
import { ImageDragAndDropComponent } from './shared/components/image-drag-and-drop/image-drag-and-drop.component';
import { FacilityDobryAgentVerificationListComponent } from './modules/facilities/facility-dobry-agent-verification-list/facility-dobry-agent-verification-list.component';
import { FacilityDobryAgentVerificationEditDialogComponent } from './shared/components/facility-dobry-agent-verification-edit-dialog/facility-dobry-agent-verification-edit-dialog.component';
import { DobryAgentNotificationSettingsComponent } from './modules/dobry-agent/dobry-agent-notification-settings/dobry-agent-notification-settings.component';
import { InvoiceDocumentsComponent } from './modules/settlements/invoices/invoice-document/invoice-documents/invoice-documents.component';
import { InvoiceDocumentListComponent } from './modules/settlements/invoices/invoice-document/invoice-document-list/invoice-document-list.component';
import { InvoiceDocumentCreateComponent } from './modules/settlements/invoices/invoice-document/invoice-document-create/invoice-document-create.component';
import { InvoiceDocumentFormComponent } from './modules/settlements/invoices/invoice-document/invoice-document-form/invoice-document-form.component';
import { InvoiceDocumentDetailsComponent } from './modules/settlements/invoices/invoice-document/invoice-document-details/invoice-document-details.component';
import { AdditionalContactPipe } from './shared/pipe/additional-contact.pipe';
import { MainContactPipe } from './shared/pipe/main-contact.pipe';
import { MainContractPhonePipe } from './shared/pipe/main-contract-phone.pipe';
import { AdditionalContractPhonePipe } from './shared/pipe/additional-contract-phone.pipe';
import { ConcludeChangeRegistrationDialogComponent } from './modules/agents-profile-hiperio/conclude-change-registration-dialog/conclude-change-registration-dialog.component';
import { DictHiperioConfigComponent } from './shared/components/dict-hiperio-config/dict-hiperio-config.component';
import { HiperioConcludeChangeRegistrationComponent } from './modules/agents-profile-hiperio/hiperio-conclude-change-registration/hiperio-conclude-change-registration.component';
import { InvoiceGeneratorComponent } from './modules/settlements/invoices/invoice-generator/invoice-generator.component';
import { DynamicDictionaryImportComponent } from './modules/dynamic-dictionary/dynamic-dictionary-import/dynamic-dictionary-import.component';
import { AllLoginLockListComponent } from './modules/login-lock/all-login-lock-list/all-login-lock-list.component';
import { LoginLockAddComponent } from './modules/login-lock/login-lock-add/login-lock-add.component';
import { LoginLockDialogComponent } from './shared/components/login-lock-dialog/login-lock-dialog.component';
import { LoginLockTimerComponent } from './shared/components/login-lock-timer/login-lock-timer.component';
import { AllPartnerTagsImportComponent } from './modules/partner-tags/all-partner-tags-import/all-partner-tags-import.component';
import { PartnerTagsImportComponent } from './modules/partner-tags/partner-tags-import/partner-tags-import.component';
import { AllCommissionTablesListComponent } from './modules/settlements/commission-tables/all-commission-tables-list/all-commission-tables-list.component';
import { AddCommissionTableComponent } from './modules/settlements/commission-tables/add-commission-table/add-commission-table.component';
import { EditCommissionTableModalComponent } from './modules/settlements/commission-tables/edit-commission-table-modal/edit-commission-table-modal.component';
import { CommissionTableDetailsComponent } from './modules/settlements/commission-tables/commission-table-details/commission-table-details.component';
import { CommissionTableDetailsViewComponent } from './modules/settlements/commission-tables/commission-table-details-view/commission-table-details-view.component';
import { DictCommissionTablesComponent } from './shared/components/dict-commission-tables/dict-commission-tables.component';
import { IddTrainingsCertificatesDetailsViewComponent } from './modules/idd-trainings/idd-trainings-certificates-details-view/idd-trainings-certificates-details-view.component';
import { IddTrainingsCertificatesEditComponent } from './modules/idd-trainings/idd-trainings-certificates-edit/idd-trainings-certificates-edit.component';
import { TimeInputComponent } from './shared/components/time-input/time-input.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    DashboardComponent,
    ListComponent,
    AddComponent,
    DictComponent,
    BreadcrumbComponent,
    DictRegionalsComponent,
    AddressFormComponent,
    ChipsInputControlComponent,
    ShowComponent,
    FacilitiesListComponent,
    FacilityAddDialogComponent,
    AllFacilitiesListComponent,
    DictPartnersComponent,
    FacilityDetailsComponent,
    FacilityAddComponent,
    PhonePipe,
    DynamicPipe,
    OfwcaAddComponent,
    OfwcaDetailsComponent,
    OfwcaAddDialogComponent,
    AllOfwcasListComponent,
    OfwcasListComponent,
    DatepickerComponent,
    PartnerFacilitySelectComponent,
    DictOfwcasComponent,
    AllInsuranceCompaniesListComponent,
    InsuranceCompanyDetailsComponent,
    DocumentAddComponent,
    AllDocumentListComponent,
    ContractAddComponent,
    ContractAddDialogComponent,
    ContractDetailsComponent,
    ContractListComponent,
    AllContractListComponent,
    ContractDetailsFormComponent,
    ContractSelectCardComponent,
    DocumentListComponent,
    DocumentAddDialogComponent,
    DocumentDetailsComponent,
    DetailComponent,
    DetailAddressComponent,
    PartnerDetailsViewComponent,
    PrimaryContactPipe,
    BillingContactPipe,
    MarketingContactPipe,
    FacilityDetailsViewComponent,
    OfwcaDetailsViewComponent,
    ContractDetailsViewComponent,
    DictInsuranceCompaniesComponent,
    DetailBoolComponent,
    DocumentDetailsViewComponent,
    AllTemplateListComponent,
    TemplateAddComponent,
    TemplateDetailsComponent,
    TemplateDetailsViewComponent,
    TemplatingConfigMapComponent,
    ConfirmDialogComponent,
    TodoComponent,
    TemplatingConfigFieldsComponent,
    TableAddressComponent,
    DictContractsComponent,
    UserAddComponent,
    AllUserListComponent,
    UserDetailsComponent,
    UserDetailsViewComponent,
    AllDepartmentListComponent,
    DepartmentAddComponent,
    DepartmentDetailsComponent,
    DepartmentDetailsViewComponent,
    DictDepartmentsComponent,
    DictUsersComponent,
    PermissionsComponent,
    CapitalizeFirstDirective,
    AvatarCropDialogComponent,
    ChangePasswordDialogComponent,
    ProfileDialogComponent,
    SlideFormFieldComponent,
    LogListComponent,
    AllKrkListComponent,
    KrkListComponent,
    KrkAddComponent,
    KrkAddDialogComponent,
    KrkDetailsComponent,
    KrkDetailsViewComponent,
    DictKrkComponent,
    PendingKrkListComponent,
    RegistrationAddComponent,
    AllRegistrationsListComponent,
    RegistrationDetailsComponent,
    RegistrationAddDialogComponent,
    DictAllContractsComponent,
    RegistrationDetailsViewComponent,
    RegistrationDetailsFormComponent,
    DictRegistrationsComponent,
    DaysDiffPipe,
    MultiLineOptionDirective,
    DeregistrationPackAddComponent,
    DeregistrationPackDetailsComponent,
    DeregistrationPackDetailsViewComponent,
    AllDeregistrationPackListComponent,
    AddRegistrationComponent,
    DictDeregistrationPacksComponent,
    ContractTerminateDialogComponent,
    InfoDialogComponent,
    ContractInsuranceCompaniesAddDialogComponent,
    AllContractInsuranceCompaniesListComponent,
    AllIdentifiersListComponent,
    IdentifierImportComponent,
    SlideToggleComponent,
    ConfirmDialogWithReasonComponent,
    AllSalesProfilesListComponent,
    AllMeetingsListComponent,
    MeetingAddComponent,
    MeetingDetailsComponent,
    MeetingDetailsViewComponent,
    MeetingsCalendarComponent,
    MeetingCalendarEventComponent,
    MonthPickerComponent,
    EnumeratePipe,
    ExamSelectDialogComponent,
    RegisteredOfwcasListComponent,
    OfwcaToRegisterListComponent,
    OfwcaMeetingListComponent,
    JobResultDialogComponent,
    AllIddTrainingsListComponent,
    IddTrainingDetailsComponent,
    IddTrainingDetailsViewComponent,
    AddIddTrainingCertificateComponent,
    IddTrainingChartComponent,
    AllIddTrainingCertificatesListComponent,
    AddIddTrainingCertificateDialogComponent,
    DecodeIddTrainingCertificatesComponent,
    DatepickerIdFormatComponent,
    FileDragAndDropComponent,
    DndDirective,
    CertificateOverviewDialogComponent,
    GoogleAuthenticatorDialogComponent,
    OfwcaToReassignListComponent,
    ChangeRegionalDialogComponent,
    PartnerChangeRegionalDialogComponent,
    AllImportsListComponent,
    ImportResultDialogComponent,
    SoldPolicyImportComponent,
    AllPoliciesListComponent,
    ReportsComponent,
    AllSoldPolicyImportsListComponent,
    MiddleClickDirective,
    AddRiskComponent,
    AllRisksListComponent,
    RiskGroupFormComponent,
    RiskGroupViewComponent,
    CommissionImportComponent,
    AllCommissionsListComponent,
    AllCommissionImportListComponent,
    CommissionDetailsComponent,
    CommissionDetailsViewComponent,
    ChildPartnersListComponent,
    EditRiskModalComponent,
    ChildPartnersListComponent,
    AllRedirectionsListComponent,
    RedirectionAddComponent,
    RedirectionDetailsComponent,
    RedirectionDetailsViewComponent,
    JobsListComponent,
    ChangePartnerDialogComponent,
    DictPartnersChipsComponent,
    CommissionDetailsFormComponent,
    AllSettlementsListComponent,
    SettlementDetailsComponent,
    SettlementDetailsViewComponent,
    AllRedirectionImportsListComponent,
    RedirectionImportComponent,
    RedirectionImportResultDialog,
    ChangeRatePaidDialogComponent,
    AddStatementDialogComponent,
    OrderIddCertificatesPipe,
    AddThresholdComponent,
    AllThresholdsListComponent,
    EditThresholdModalComponent,
    ThresholdGroupFormComponent,
    ThresholdGroupViewComponent,
    AddAnnexComponent,
    AllAnnexesListComponent,
    EditAnnexModalComponent,
    AnnexGroupFormComponent,
    AnnexGroupViewComponent,
    DictThresholdsComponent,
    UpdateCurrentDynamicsDialogComponent,
    AddRiskDictComponent,
    AllRiskDictsListComponent,
    EditRiskDictModalComponent,
    RiskDictGroupFormComponent,
    RiskDictGroupViewComponent,
    DictRiskDictsComponent,
    SplitPipe,
    ContractOfwcaApplicationsListComponent,
    OfwcasListDialogComponent,
    ContractInsuranceCompaniesSelectDialogComponent,
    CrossCompanyReportDialogComponent,
    MassEditionComponent,
    MassEditionDialogComponent,
    AllInvoicesListComponent,
    AddInvoiceComponent,
    InvoiceDetailsComponent,
    InvoiceDetailsViewComponent,
    ChangeStatusDialogComponent,
    CreateDocumentDialogComponent,
    TemplateComponent,
    AllPaymentListComponent,
    PaymentHistoryComponent,
    DictCommissionSettlementComponent,
    DictIddTrainingTrainerComponent,
    AddInitialBalanceComponent,
    AllCommissionsListInvoicesComponent,
    SubmissionsComponent,
    NewsletterListComponent,
    NewsletterDetailsComponent,
    NewsletterDetailsViewComponent,
    NewsletterCurrentComponent,
    NewsletterAddComponent,
    NewsletterPdfViewComponent,
    RegistrationsAddMultipleComponent,
    RegistrationsAddMultipleDialogComponent,
    JobsListDialogComponent,
    AllRegionalListComponent,
    RegionalDetailsComponent,
    RegionalDetailsViewComponent,
    RegionalAddComponent,
    ReportCustomComponent,
    AddInsuranceCompanyComponent,
    ChangeAccountNumberDialogComponent,
    OfwcaChangeAccountNumberDialogComponent,
    EditInvoiceComponent,
    AllSupportListComponent,
    SupportAddComponent,
    SupportDetailsComponent,
    SupportDetailsViewComponent,
    ReportPartnersComponent,
    ReportOfwcasComponent,
    ReportContractsComponent,
    ReportRegistrationsComponent,
    ReportIdentifiersComponent,
    ReportRedirectionComponent,
    AllLicensedAgentComponent,
    AllNoteListComponent,
    NoteListComponent,
    NoteAddComponent,
    NoteAddDialogComponent,
    NoteDetailsComponent,
    NoteDetailsViewComponent,
    AllContractBalanceListComponent,
    ContractBalanceDetailsComponent,
    ContractBalanceDetailsViewComponent,
    ContractInitialBalanceDetailsViewComponent,
    SearchEngineComponent,
    AddBillsComponent,
    BillsFileDragAndDropComponent,
    OfwcaRegisteredListComponent,
    AddSettlementsTemplateComponent,
    AllSettlementsTemplateListComponent,
    SettlementsTemplateComponent,
    SettlementsTemplateViewComponent,
    AddSettlementsTemplateDialogComponent,
    SendMailDialogComponent,
    LoginLogListComponent,
    DictOfwcasPartnersComponent,
    ContractInvoiceNumberEditComponent,
    TuTemplateComponent,
    CrmUserPermissionsListComponent,
    CrmUserPermissionsAddComponent,
    OfwcaChangeHiperioDataComponent,
    AllPostListComponent,
    PostAddComponent,
    PostDetailsComponent,
    PostDetailsViewComponent,
    AllTagsListComponent,
    TagsAddComponent,
    DictTagComponent,
    AllPermissionTagsListComponent,
    PermissionTagsAddComponent,
    DictPermissionTagsComponent,
    AllFacilitiesVerificationSalesProcessListComponent,
    FacilitiesVerificationSalesProcessAddComponent,
    VerificationSalesProcessViewComponent,
    AllBankFilesListComponent,
    CommissionMarginReportListComponent,
    AllCorporationListComponent,
    CorporationAddComponent,
    CorporationDetailsComponent,
    CorporationDetailsViewComponent,
    PermissionTagsDetailsComponent,
    PermissionTagsDetailsViewComponent,
    AddPermissionTagUserComponent,
    AllSelfBillingFormListComponent,
    AddressImportComponent,
    AllAddressImportComponent,
    AllAddressImportRowComponent,
    DictAddressComponent,
    TagsDetailsComponent,
    TagsDetailsViewComponent,
    UsersDialogComponent,
    OckAddComponent,
    DocumentPreviewComponent,
    DynamicDictComponent,
    AllDynamicDictionaryListComponent,
    DynamicDictionaryAddComponent,
    DynamicDictionaryDetailsComponent,
    DynamicDictionaryDetailsViewComponent,
    CalendarComponent,
    MeetingDetailsViewDialogComponent,
    MeetingAddDialogComponent,
    AddressAddComponent,
    CalendarDialogComponent,
    CalendarEventComponent,
    OfwcasMissingDocumentsComponent,
    ReportListComponent,
    PermissionTagsUserImportComponent,
    AddDynamicFormComponent,
    DynamicFormListComponent,
    DynamicFormsDetailsComponent,
    DynamicFormsDetailsViewComponent,
    DynamicFormApplyListComponent,
    DynamicFormViewComponent,
    ReceivablesImportComponent,
    AllReceivablesImportsListComponent,
    AllReceivablesImportsRowListComponent,
    ReceivablesImportsRowDetailsComponent,
    ReceivablesImportsRowDetailsViewComponent,
    ReceivablesJobListComponent,
    ChangeRegistrationDialogComponent,
    AllReceivablesStatementListComponent,
    StatementAddComponent,
    ReceivablesStatementDetailsComponent,
    ReceivablesStatementDetailsViewComponent,
    ReceivablesImportsRowListComponent,
    AddEmailToFormDialogComponent,
    AddPartnerToFormDialogComponent,
    ChangeFormRowStatusDialogComponent,
    AllReceivablesBalanceListComponent,
    ReceivablesPaymentImportComponent,
    AllReceivablesPaymentImportListComponent,
    AllReceivablesPaymentImportRowListComponent,
    ReceivablesPaymentImportRowDetailsComponent,
    ReceivablesPaymentImportRowDetailsViewComponent,
    ChangeStatementDialogComponent,
    ReceivablesBalanceDetailsComponent,
    ReceivablesBalanceDetailsViewComponent,
    StatementAddDialogComponent,
    ReceivablesPaymentImportAddComponent,
    RegistrationIdentifiersComponent,
    RegistrationIdentifiersFormComponent,
    AllReceivablesBalanceHistoryListComponent,
    ReceivablesBalanceAddDialogComponent,
    DictReceivablesBalanceComponent,
    PolicyOverrideDialogComponent,
    CloneAnnexesDialogComponent,
    EmailSendAddComponent,
    EmailSendJobListComponent,
    EmailSendDetailsComponent,
    EmailSendDetailsViewComponent,
    ReceivablesPaymentImportRowAddComponent,
    ProductContactPipe,
    IddTrainingsTrainerListComponent,
    AddIddTrainingsTrainerComponent,
    IddTrainingsTrainerDetailsComponent,
    IddTrainingsTrainerDetailsViewComponent,
    OfwcaRejectedCommissionAddComponent,
    CancelRegistrationDialogComponent,
    OckCompanyListComponent,
    OckPolicyListComponent,
    OckUserListComponent,
    OckImportComponent,
    AllOckImportListComponent,
    AllNipListComponent,
    AllVinListComponent,
    NipAddComponent,
    VinAddComponent,
    CommissionUpdatePackageListComponent,
    CommissionUpdatePackageDetailsComponent,
    CommissionUpdatePackageViewComponent,
    CommissionUpdatePackageAddComponent,
    AllTerminalsListComponent,
    AddTerminalDialogComponent,
    AddLicensedComponent,
    LicensedDetailsComponent,
    LicensedDetailsViewComponent,
    LicensedDetailsFormComponent,
    TerminalsDetailsComponent,
    TerminalsDetailsViewComponent,
    AllTerminalsImportsListComponent,
    TerminalsImportComponent,
    AllTerminalsImportsRowListComponent,
    TerminalsImportsRowDetailsComponent,
    TerminalsImportsRowDetailsViewComponent,
    TerminalsBankJobListComponent,
    ChangePartnerFacilityDialogComponent,
    ChangeTerminalsImportRowDialogComponent,
    DictTerminalImportRowComponent,
    TerminalsDetailsFormComponent,
    AffiliateCodeListComponent,
    AffiliateCodeAddDialogComponent,
    AffiliateCodeDetailsComponent,
    AffiliateCodeDetailsViewComponent,
    FileManagerListComponent,
    AddCatalogDialogComponent,
    AddFileDialogComponent,
    TagAddComponent,
    AllTagListComponent,
    DictTagFileManagerComponent,
    AllSharedFileListComponent,
    SharedFileAddComponent,
    AddPageComponent,
    PageListComponent,
    PageDetailsComponent,
    PageDetailsViewComponent,
    DictPageFileManagerComponent,
    ReceivablesBalanceUpdateOfwcaComponent,
    ReceivablesBalanceUpdatePartnerFacilityComponent,
    AllPersonalDataChangeListComponent,
    PersonalDataChangeDetailsViewComponent,
    PersonalDataChangeDetailsComponent,
    ChroniePaymentListComponent,
    ChronieJobListComponent,
    IssueInsurancePolicyChronieDialogComponent,
    TransferBankJobListComponent,
    TransferDetailsComponent,
    TransferDetailsViewComponent,
    TransferListComponent,
    TransferAddComponent,
    AllCommissionImportRowSettledListComponent,
    ConfirmDialogWithDictComponent,
    DictDobryAgentPartnersComponent,
    AllBlockedNipListComponent,
    BlockedNipAddDialogComponent,
    BlockedNipAddComponent,
    ApplicationsComponent,
    AllIddTrainingCertificatesToCheckListComponent,
    IddCertificateEditDialogComponent,
    DenyIddCertificateDialogComponent,
    AllEmployeeListComponent,
    EmployeeDetailsComponent,
    EmployeeDetailsViewComponent,
    LeaveApplicationAddDialogComponent,
    LeaveApplicationListComponent,
    LeaveApplicationDetailsComponent,
    LeaveApplicationDetailsViewComponent,
    EmployeeDetailsFormComponent,
    AllLeaveApplicationListComponent,
    LeaveApplicationAddFileComponent,
    ReceivablesBalanceNoteAddComponent,
    ReceivablesBalanceNoteListComponent,
    MinutesToHHmmPipe,
    ChangeStatusReceivablesImportsRowDialogComponent,
    LeaveApplicationEditComponent,
    LicenseAddComponent,
    LicenseAddDialogComponent,
    LicenseDetailsComponent,
    LicenseDetailsViewComponent,
    AllLicenseListComponent,
    UserLicensesDetailsComponent,
    UserLicensesDetailsViewComponent,
    DeviceAddComponent,
    DeviceAddDialogComponent,
    AllDeviceListComponent,
    DictUserDevicesComponent,
    DeviceDetailsComponent,
    DeviceDetailsViewComponent,
    AllWarehouseProductListComponent,
    WarehouseProductDetailsViewComponent,
    WarehouseProductAddDialogComponent,
    WarehouseProductAddComponent,
    WarehouseProductDetailsComponent,
    CompetitionDataImportComponent,
    AdditionalFieldsListComponent,
    AdditionalFieldsAddComponent,
    AdditionalFieldsAddDialogComponent,
    CompetitionImportListComponent,
    DictAdditionalFieldsComponent,
    AdditionalFieldsDetailsComponent,
    AdditionalFieldsDetailsViewComponent,
    CompetitionListComponent,
    CompetitionImportRowListComponent,
    CompetitionImportRowDetailsComponent,
    CompetitionImportRowDetailsViewComponent,
    CompetitionImportValuesListComponent,
    EditCompetitionImportRowComponent,
    EditDialogCompetitionImportRowComponent,
    DictWarehouseProductsComponent,
    CompetitionImportValuesListComponent,
    ReceivablesPaymentImportTransferAddComponent,
    CompetitionWzListComponent,
    CompetitionWzRowsListComponent,
    LogDeletedDataListComponent,
    TerminalsNoteAddComponent,
    ReceivablesPaymentImportTransferAddComponent,
    HiperioRegistrationConfigComponent,
    HiperioRegistrationConfigDetailsComponent,
    HiperioRegistrationConfigDetailsViewComponent,
    ChangeRegistrationHiperioDialogComponent,
    ChangeParameterDialogComponent,
    UserJobsListComponent,
    CredentialsJobsListComponent,
    HiperioTestAccessFormListComponent,
    FacilityDobryAgentSelectComponent,
    FacilityDobryAgentViewComponent,
    ApplicationPermissionComponent,
    FacilityDobryAgentAddComponent,
    DictDobryAgentSelectComponent,
    InsuranceCompanyDobryAgentSelectComponent,
    CityDobryAgentSelectComponent,
    PaymentMethodDobryAgentSelectComponent,
    SubCategoryDobryAgentSelectComponent,
    AffiliateCodeSelectComponent,
    GooglePlaceDobryAgentSelectComponent,
    ImageDragAndDropComponent,
    FacilityDobryAgentVerificationListComponent,
    FacilityDobryAgentVerificationEditDialogComponent,
    DobryAgentNotificationSettingsComponent,
    InvoiceDocumentsComponent,
    InvoiceDocumentListComponent,
    InvoiceDocumentCreateComponent,
    InvoiceDocumentFormComponent,
    InvoiceDocumentDetailsComponent,
    DictWarehouseProductsComponent,
    AdditionalContactPipe,
    MainContactPipe,
    MainContractPhonePipe,
    AdditionalContractPhonePipe,
    ConcludeChangeRegistrationDialogComponent,
    DictHiperioConfigComponent,
    HiperioConcludeChangeRegistrationComponent,
    InvoiceGeneratorComponent,
    DynamicDictionaryImportComponent,
    AllLoginLockListComponent,
    LoginLockAddComponent,
    LoginLockDialogComponent,
    LoginLockTimerComponent,
    InvoiceGeneratorComponent,
    AllPartnerTagsImportComponent,
    PartnerTagsImportComponent,
    AllCommissionTablesListComponent,
    AddCommissionTableComponent,
    EditCommissionTableModalComponent,
    CommissionTableDetailsComponent,
    CommissionTableDetailsViewComponent,
    DictCommissionTablesComponent,
    IddTrainingsCertificatesDetailsViewComponent,
    IddTrainingsCertificatesEditComponent,
    TimeInputComponent,
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatSidenavModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatDividerModule,
        MatListModule,
        HttpClientModule,
        MatTableModule,
        MatPaginatorModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatSelectModule,
        MatCardModule,
        FlexLayoutModule,
        MatChipsModule,
        ReactiveFormsModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatTabsModule,
        MatDialogModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MaterialFileInputModule,
        MatTooltipModule,
        MatExpansionModule,
        MatRippleModule,
        NgxMatSelectSearchModule,
        ImageCropperModule,
        MatProgressBarModule,
        MatSortModule,
        MatRadioModule,
        MatCheckboxModule,
        NgxMaterialTimepickerModule,
        MatProgressSpinnerModule,
        NgxMaskModule.forRoot(),
        MatBadgeModule,
        StoreModule.forRoot(reducers),
        StoreDevtoolsModule.instrument({
            maxAge: 25, // Retains last 25 states
            logOnly: true, // Restrict extension to log-only mode
        }),
        StoreRouterConnectingModule.forRoot({
            serializer: RouteSerializer,
        }),
        AngularEditorModule,
        NgxExtendedPdfViewerModule,
        DragDropModule,
        FullCalendarModule,
        FormsModule
    ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AccessDeniedInterceptor, multi: true },
    { provide: MatPaginatorIntl, useValue: getPolishPaginationIntl() },
    PhonePipe,
    MinutesToHHmmPipe,
    MatDatepickerModule,
    PrimaryContactPipe,
    BillingContactPipe,
    MarketingContactPipe,
    KeyValuePipe,
    DaysDiffPipe,
    EnumeratePipe,
    OrderIddCertificatesPipe,
    ProductContactPipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
